import "./sprinkles.css.ts.vanilla.js";
import "./feedback.css.ts.vanilla.js";
var n = "gx6h6a3 _1y2v1nf5i _1y2v1nf85 _1y2v1nf7p", r = "_1y2v1nf9l _1y2v1nf5i _1y2v1nf5u", t = "gx6h6a1", v = "gx6h6a7", p = "gx6h6a5", f = "gx6h6a6", i = "gx6h6a4";
export { n as container, r as desktopContainer, t as desktopContent, v as feedbackData, p as feedbackDataAppear, f as feedbackDataAppearActive, i as innerContainer };
